import { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:3001";

function dataHojeBR() {
  return new Date().toLocaleDateString("sv-SE", {
    timeZone: "America/Sao_Paulo",
  });
}

function normalizarUrl(url) {
  if (!url) return "";
  if (String(url).startsWith("http")) return url;
  if (String(url).startsWith("/uploads")) return `${API_BASE}${url}`;
  if (String(url).startsWith("uploads")) return `${API_BASE}/${url}`;
  return url;
}

export default function Relatorios() {
  const [periodo, setPeriodo] = useState("semana");
  const [dataManualInicio, setDataManualInicio] = useState("");
  const [dataManualFim, setDataManualFim] = useState("");
  const [resultado, setResultado] = useState(null);
  const [textoWhatsApp, setTextoWhatsApp] = useState("");
  const [dadosGrafico, setDadosGrafico] = useState([]);
  const [me, setMe] = useState(null);

  const [royaltiesAtivo, setRoyaltiesAtivo] = useState(false);
  const [percentualRoyalties, setPercentualRoyalties] = useState("30");
  const [tipoRoyalties, setTipoRoyalties] = useState("liquido");
  const [nomeRoyalties, setNomeRoyalties] = useState("Santiago");
  const [nomeResponsavel, setNomeResponsavel] = useState("Ellan");
  const [royaltiesSemanais, setRoyaltiesSemanais] = useState([]);
  const [configCarregada, setConfigCarregada] = useState(false);

  const [lendoBanco, setLendoBanco] = useState(false);
  const [bancoNome, setBancoNome] = useState("Inter");
  const [valorBanco, setValorBanco] = useState("");
  const [arquivoBanco, setArquivoBanco] = useState(null);
  const [bancoPrintUrl, setBancoPrintUrl] = useState("");
  const [bancoPrintTipo, setBancoPrintTipo] = useState("");

  // Segundo banco do fechamento consolidado.
  const [arquivoOutroBanco, setArquivoOutroBanco] = useState(null);
  const [outroBancoPrintUrl, setOutroBancoPrintUrl] = useState("");
  const [outroBancoPrintTipo, setOutroBancoPrintTipo] = useState("");

  const [arquivoTrafego, setArquivoTrafego] = useState(null);
  const [trafegoPrintUrl, setTrafegoPrintUrl] = useState("");
  const [trafegoPrintTipo, setTrafegoPrintTipo] = useState("");

  const [enviandoSistema, setEnviandoSistema] = useState(false);
  const [historicoConsolidado, setHistoricoConsolidado] = useState([]);
  const [toast, setToast] = useState("");

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const opcoesPercentualRoyalties = [10, 20, 25, 30, 35, 40, 50];

  function getTokenAtual() {
    return (
      localStorage.getItem("token") ||
      sessionStorage.getItem("token") ||
      ""
    );
  }

  function ehColaboradorUsuario(usuario = me) {
    const role = String(usuario?.role || "").toLowerCase();
    const plano = String(usuario?.plano || "").toLowerCase();

    return role === "colaborador" || plano.includes("colaborador");
  }


  useEffect(() => {
    iniciar();
  }, []);

  async function iniciar() {
    await carregarConfiguracoes();
    await carregarMe();
    await carregarHistoricoConsolidado();
  }

  async function carregarMe() {
    if (!getTokenAtual()) return;

    try {
      const res = await fetch(`${API_BASE}/me`, {
        headers: { Authorization: getTokenAtual() },
      });

      const dados = await res.json();
      setMe(dados);
    } catch (err) {
      console.log("Erro ao carregar usuário:", err);
    }
  }

  async function carregarConfiguracoes() {
    if (!getTokenAtual()) return;

    try {
      const res = await fetch(`${API_BASE}/configuracoes`, {
        headers: { Authorization: getTokenAtual() },
      });

      const dados = await res.json();

      if (dados?.royalties) {
        const sugestaoRecebedor =
          dados?.sugestoesRoyalties?.nomeRecebedor ||
          dados?.superior?.nomeEmpresa ||
          "Superior";

        const sugestaoResponsavel =
          dados?.sugestoesRoyalties?.nomeResponsavel ||
          dados?.nomeEmpresa ||
          "Minha Empresa";

        const nomeRecebedorAtual = dados.royalties.nomeRecebedor || "";
        const nomeResponsavelAtual = dados.royalties.nomeResponsavel || "";

        setRoyaltiesAtivo(Boolean(dados.royalties.ativo));
        const percentualCarregado = Number(dados.royalties.percentual ?? 30);
        setPercentualRoyalties(
          opcoesPercentualRoyalties.includes(percentualCarregado)
            ? String(percentualCarregado)
            : "30"
        );
        setTipoRoyalties(dados.royalties.tipo || "liquido");
        setNomeRoyalties(
          !nomeRecebedorAtual || nomeRecebedorAtual === "Santiago"
            ? sugestaoRecebedor
            : nomeRecebedorAtual
        );
        setNomeResponsavel(
          !nomeResponsavelAtual || nomeResponsavelAtual === "Ellan"
            ? sugestaoResponsavel
            : nomeResponsavelAtual
        );
      }

      setConfigCarregada(true);
    } catch (err) {
      console.log("Erro ao carregar configurações:", err);
      setConfigCarregada(true);
    }
  }

  async function carregarHistoricoConsolidado() {
    if (!getTokenAtual()) return;

    try {
      const res = await fetch(`${API_BASE}/relatorios-recebidos`, {
        headers: { Authorization: getTokenAtual() },
      });

      const dados = await res.json();

      if (Array.isArray(dados)) {
        const meus = dados.filter(
          (item) =>
            item.tipoRelatorio === "consolidado" &&
            (!me?.email || item.usuario === me.email)
        );

        setHistoricoConsolidado(meus.slice(0, 20));
      }
    } catch (err) {
      console.log("Erro ao carregar histórico consolidado:", err);
    }
  }

  async function salvarConfiguracoes(novaConfig = {}) {
    if (!getTokenAtual() || !configCarregada) return;

    const config = {
      ativo: novaConfig.ativo ?? royaltiesAtivo,
      percentual: novaConfig.percentual ?? percentualRoyalties,
      tipo: novaConfig.tipo ?? tipoRoyalties,
      nomeRecebedor: novaConfig.nomeRecebedor ?? nomeRoyalties,
      nomeResponsavel: novaConfig.nomeResponsavel ?? nomeResponsavel,
    };

    try {
      await fetch(`${API_BASE}/configuracoes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getTokenAtual(),
        },
        body: JSON.stringify({
          royalties: {
            ativo: Boolean(config.ativo),
            percentual: Number(config.percentual || 0),
            tipo: config.tipo,
            nomeRecebedor: config.nomeRecebedor,
            nomeResponsavel: config.nomeResponsavel,
          },
        }),
      });
    } catch (err) {
      console.log("Erro ao salvar configurações:", err);
    }
  }

  function mostrarToast(msg) {
    setToast(msg);
    setTimeout(() => setToast(""), 3500);
  }

  function formatarMoedaInput(valor) {
    const somenteNumeros = String(valor || "").replace(/\D/g, "");
    if (!somenteNumeros) return "";
    const numero = Number(somenteNumeros) / 100;
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function formatarNumeroComoMoeda(valor) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function moedaParaNumero(valor) {
    if (!valor) return 0;

    const texto = String(valor)
      .replace("R$", "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(",", ".");

    const numero = Number(texto);
    return Number.isNaN(numero) ? 0 : numero;
  }

  function obterSemanaSabadoSexta(offsetSemanas = 0) {
    const hojeBR = dataHojeBR();
    const hoje = new Date(hojeBR + "T00:00:00");

    const inicioHoje = new Date(
      hoje.getFullYear(),
      hoje.getMonth(),
      hoje.getDate()
    );

    const diaSemana = inicioHoje.getDay();
    const diasDesdeSabado = (diaSemana + 1) % 7;

    const inicio = new Date(inicioHoje);
    inicio.setDate(inicio.getDate() - diasDesdeSabado + offsetSemanas * 7);

    const fim = new Date(inicio);
    fim.setDate(fim.getDate() + 6);

    return { inicio, fim };
  }

  function obterPeriodoSelecionado() {
    const hojeBR = dataHojeBR();
    const hoje = new Date(hojeBR + "T00:00:00");

    if (periodo === "manual") {
      const inicioManual = String(dataManualInicio || "").slice(0, 10);
      const fimManual = String(dataManualFim || "").slice(0, 10);

      if (!inicioManual || !fimManual) {
        return { inicio: "", fim: "" };
      }

      return inicioManual <= fimManual
        ? { inicio: inicioManual, fim: fimManual }
        : { inicio: fimManual, fim: inicioManual };
    }

    if (periodo === "semana") {
      const { inicio, fim } = obterSemanaSabadoSexta(0);
      return {
        inicio: inicio.toISOString().slice(0, 10),
        fim: fim.toISOString().slice(0, 10),
      };
    }

    if (periodo === "semana_anterior") {
      const { inicio, fim } = obterSemanaSabadoSexta(-1);
      return {
        inicio: inicio.toISOString().slice(0, 10),
        fim: fim.toISOString().slice(0, 10),
      };
    }

    if (periodo === "mes") {
      const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      return {
        inicio: inicio.toISOString().slice(0, 10),
        fim: fim.toISOString().slice(0, 10),
      };
    }

    if (periodo === "3meses") {
      const inicio = new Date(hoje);
      inicio.setMonth(inicio.getMonth() - 3);
      return {
        inicio: inicio.toISOString().slice(0, 10),
        fim: hoje.toISOString().slice(0, 10),
      };
    }

    const inicio = new Date(hoje.getFullYear(), 0, 1);
    const fim = new Date(hoje.getFullYear(), 11, 31);

    return {
      inicio: inicio.toISOString().slice(0, 10),
      fim: fim.toISOString().slice(0, 10),
    };
  }

  function obterSemanaPorData(dataRelatorio) {
    const data = new Date(dataRelatorio + "T00:00:00");
    const diaSemana = data.getDay();
    const diasDesdeSabado = (diaSemana + 1) % 7;

    const inicio = new Date(data);
    inicio.setDate(inicio.getDate() - diasDesdeSabado);

    const fim = new Date(inicio);
    fim.setDate(fim.getDate() + 6);

    return { inicio, fim };
  }

  function dentroDoPeriodo(dataRelatorio) {
    const data = String(dataRelatorio || "").slice(0, 10);
    if (!data) return false;

    const periodoSelecionado = obterPeriodoSelecionado();

    if (!periodoSelecionado.inicio || !periodoSelecionado.fim) {
      return false;
    }

    return data >= periodoSelecionado.inicio && data <= periodoSelecionado.fim;
  }

  function relatorioPertenceAoGrupoDaFranquia(item, usuarioLogado) {
    if (!item || !usuarioLogado?.email) return false;

    const meuEmail = String(usuarioLogado.email || "");
    const meuId = String(usuarioLogado.id || usuarioLogado._id || "");

    if (String(item.usuario || "") === meuEmail) {
      return true;
    }

    // Colaborador direto da franquia/gestor logado.
    // Essa é a correção do consolidado semanal/royalties:
    // a página Relatórios precisa somar a franquia + colaboradores diretos.
    if (
      usuarioLogado.role !== "colaborador" &&
      String(item.role || "") === "colaborador" &&
      meuId &&
      String(item.parentId || "") === meuId
    ) {
      return true;
    }

    return false;
  }

  function formatarDataBR(data) {
    return data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
    });
  }

  function formatarDataISOParaBR(dataISO = "") {
    const partes = String(dataISO || "").slice(0, 10).split("-");
    if (partes.length !== 3) return dataISO || "";
    return `${partes[2]}/${partes[1]}`;
  }

  function nomePeriodo() {
    if (periodo === "manual") {
      const selecionado = obterPeriodoSelecionado();
      if (!selecionado.inicio || !selecionado.fim) return "Período manual";
      return `Período manual ${formatarDataISOParaBR(selecionado.inicio)} a ${formatarDataISOParaBR(selecionado.fim)}`;
    }

    if (periodo === "semana") {
      const { inicio, fim } = obterSemanaSabadoSexta(0);
      return `Semana ${formatarDataBR(inicio)} a ${formatarDataBR(fim)}`;
    }

    if (periodo === "semana_anterior") {
      const { inicio, fim } = obterSemanaSabadoSexta(-1);
      return `Semana anterior ${formatarDataBR(inicio)} a ${formatarDataBR(fim)}`;
    }

    if (periodo === "mes") return "Mês";
    if (periodo === "3meses") return "Últimos 3 meses";
    if (periodo === "ano") return "Ano";

    return "";
  }

  function tipoConsolidado() {
    if (periodo === "semana" || periodo === "semana_anterior" || periodo === "manual") return "semanal";
    if (periodo === "mes") return "mensal";
    if (periodo === "3meses") return "trimestral";
    return "anual";
  }

  function tituloRelatorio() {
    if (periodo === "semana") return "RELATÓRIO SEMANAL";
    if (periodo === "semana_anterior") return "RELATÓRIO SEMANAL - SEMANA ANTERIOR";
    if (periodo === "manual") return "RELATÓRIO SEMANAL - PERÍODO MANUAL";
    if (periodo === "mes") return "RELATÓRIO MENSAL";
    if (periodo === "3meses") return "RELATÓRIO ÚLTIMOS 3 MESES";
    if (periodo === "ano") return "RELATÓRIO ANUAL";
    return "RELATÓRIO";
  }

  function calcularGastosDoRelatorio(item) {
    const trafego = Number(item.gastoTrafego || 0);

    let outrosGastos = 0;

    if (
      item.totalOutrosGastos !== undefined &&
      item.totalOutrosGastos !== null &&
      item.totalOutrosGastos !== ""
    ) {
      outrosGastos = Number(item.totalOutrosGastos || 0);
    } else if (Array.isArray(item.outrosGastos)) {
      outrosGastos = item.outrosGastos.reduce(
        (acc, gasto) => acc + Number(gasto.valor || 0),
        0
      );
    }

    let totalGastosCalculado = trafego + outrosGastos;

    if (
      item.totalGastos !== undefined &&
      item.totalGastos !== null &&
      item.totalGastos !== ""
    ) {
      totalGastosCalculado = Number(item.totalGastos || 0);
    }

    const creditoServidor = Number(item.creditoServidor || 0);
    const lucroBase =
      item.lucroLiquido !== undefined && item.lucroLiquido !== null
        ? Number(item.lucroLiquido || 0)
        : Number(item.faturamento || 0) - totalGastosCalculado;
    const meuLucro =
      item.lucroRealEmpresa !== undefined && item.lucroRealEmpresa !== null
        ? Number(item.lucroRealEmpresa || 0)
        : lucroBase - creditoServidor;

    return {
      trafego,
      outrosGastos,
      creditoServidor,
      meuLucro,
      totalGastosCalculado,
    };
  }

  function calcularDevolucoesDoRelatorio(item) {
    if (!item) return 0;

    if (
      item.totalDevolucoes !== undefined &&
      item.totalDevolucoes !== null &&
      item.totalDevolucoes !== ""
    ) {
      return Number(item.totalDevolucoes || 0);
    }

    if (Array.isArray(item.devolucoes)) {
      return item.devolucoes.reduce(
        (acc, devolucao) => acc + Number(devolucao.valor || 0),
        0
      );
    }

    return 0;
  }


  function calcularFaturamentoValidoDoRelatorio(item) {
    if (!item) return 0;

    return Number(item.faturamento || 0);
  }

  function calcularEntradaBrutaDoRelatorio(item) {
    if (!item) return 0;

    const faturamentoValido = calcularFaturamentoValidoDoRelatorio(item);
    const devolucoesItem = calcularDevolucoesDoRelatorio(item);
    const brutoInformado = Number(item.faturamentoBruto || 0);

    // Regra segura:
    // Entrada bruta nunca pode ser menor que faturamento válido + devoluções.
    // Isso corrige relatórios antigos salvos antes da separação bruto/devolução.
    const brutoCalculado = faturamentoValido + devolucoesItem;

    return Math.max(brutoInformado, brutoCalculado);
  }

  function agruparDevolucoes(relatorios) {
    const mapa = {};

    relatorios.forEach((relatorio) => {
      if (!Array.isArray(relatorio.devolucoes)) return;

      relatorio.devolucoes.forEach((item) => {
        const descricao = String(item.descricao || "").trim();
        const valor = Number(item.valor || 0);

        if (!descricao && valor <= 0) return;

        const chave = (descricao || "Devolução / estorno").toLowerCase();

        if (!mapa[chave]) {
          mapa[chave] = {
            descricao: descricao || "Devolução / estorno",
            valor: 0,
            comprovanteUrl: item.comprovanteUrl || item.arquivoUrl || "",
          };
        }

        mapa[chave].valor += valor;
      });
    });

    return Object.values(mapa).filter((item) => item.valor > 0);
  }

  function agruparOutrosGastos(relatorios) {
    const mapa = {};

    relatorios.forEach((relatorio) => {
      if (!Array.isArray(relatorio.outrosGastos)) return;

      relatorio.outrosGastos.forEach((gasto) => {
        const descricao = String(gasto.descricao || "").trim();

        if (!descricao) return;

        const chave = descricao.toLowerCase();
        const valor = Number(gasto.valor || 0);

        if (!mapa[chave]) {
          mapa[chave] = {
            descricao,
            valor: 0,
          };
        }

        mapa[chave].valor += valor;
      });
    });

    return Object.values(mapa).filter((item) => item.valor > 0);
  }

  function calcularCrescimento(atual, anterior, tipo = "normal") {
    const atualNum = Number(atual || 0);
    const anteriorNum = Number(anterior || 0);

    if (anteriorNum === 0) return null;

    if (tipo === "lucro" && (atualNum < 0 || anteriorNum < 0)) {
      return "queda";
    }

    let crescimento = ((atualNum - anteriorNum) / anteriorNum) * 100;

    if (crescimento > 999) crescimento = 999;
    if (crescimento < -99) crescimento = -99;

    return Number(crescimento.toFixed(1));
  }

  function gerarDadosGraficoMensal(relatorios) {
    const agrupado = {};

    relatorios.forEach((item) => {
      if (!item.data) return;

      const dataObj = new Date(item.data + "T00:00:00");
      const chave = item.data.slice(0, 7);

      const mesFormatado = dataObj.toLocaleString("pt-BR", {
        month: "short",
        year: "2-digit",
      });

      const gastos = calcularGastosDoRelatorio(item);

      const totalGastos =
        Number(item.totalGastos || 0) || gastos.totalGastosCalculado;

      const lucro =
        Number(item.lucroLiquido || 0) ||
        Number(item.faturamento || 0) - totalGastos;

      if (!agrupado[chave]) {
        agrupado[chave] = {
          mes: mesFormatado,
          ordem: new Date(chave),
          faturamento: 0,
          faturamentoBruto: 0,
          devolucoes: 0,
          gastos: 0,
          creditoServidor: 0,
          meuLucro: 0,
          lucro: 0,
          crescimentoFaturamento: null,
          crescimentoLucro: null,
        };
      }

      const devolucoesItem = calcularDevolucoesDoRelatorio(item);
      const faturamentoValidoItem = calcularFaturamentoValidoDoRelatorio(item);
      const entradaBrutaItem = calcularEntradaBrutaDoRelatorio(item);

      agrupado[chave].faturamento += faturamentoValidoItem;
      agrupado[chave].faturamentoBruto += entradaBrutaItem;
      agrupado[chave].devolucoes += devolucoesItem;
      agrupado[chave].gastos += totalGastos;
      agrupado[chave].creditoServidor += gastos.creditoServidor;
      agrupado[chave].meuLucro += gastos.meuLucro;
      agrupado[chave].lucro += lucro;
    });

    const resultado = Object.values(agrupado).sort(
      (a, b) => a.ordem - b.ordem
    );

    resultado.forEach((mes, index) => {
      if (index === 0) return;

      const anterior = resultado[index - 1];

      mes.crescimentoFaturamento = calcularCrescimento(
        mes.faturamento,
        anterior.faturamento
      );

      mes.crescimentoLucro = calcularCrescimento(
        mes.lucro,
        anterior.lucro,
        "lucro"
      );
    });

    return resultado;
  }

  function calcularRoyalties(resumo) {
    if (ehColaboradorUsuario()) return 0;
    if (!royaltiesAtivo) return 0;

    const percentual = Number(percentualRoyalties || 0);
    const base =
      tipoRoyalties === "bruto" ? resumo.faturamento : resumo.lucroLiquido;

    return (base * percentual) / 100;
  }

  function calcularMeuLucroResumo(resumo, royalties = 0) {
    return (
      Number(resumo?.lucroLiquido || 0) -
      Number(royalties || 0) -
      Number(resumo?.creditoServidor || 0)
    );
  }

  function gerarRoyaltiesSemanais(relatorios) {
    if (ehColaboradorUsuario()) return [];

    const agrupado = {};

    relatorios.forEach((item) => {
      if (!item.data) return;

      const { inicio, fim } = obterSemanaPorData(item.data);
      const chave = inicio.toISOString().slice(0, 10);

      const gastos = calcularGastosDoRelatorio(item);

      const totalGastos =
        Number(item.totalGastos || 0) || gastos.totalGastosCalculado;

      const lucro =
        Number(item.lucroLiquido || 0) ||
        Number(item.faturamento || 0) - totalGastos;

      if (!agrupado[chave]) {
        agrupado[chave] = {
          periodo: `${formatarDataBR(inicio)} a ${formatarDataBR(fim)}`,
          inicio,
          faturamento: 0,
          gastos: 0,
          creditoServidor: 0,
          lucroLiquido: 0,
          meuLucro: 0,
          royalties: 0,
          restante: 0,
        };
      }

      agrupado[chave].faturamento += calcularFaturamentoValidoDoRelatorio(item);
      agrupado[chave].gastos += totalGastos;
      agrupado[chave].creditoServidor += gastos.creditoServidor;
      agrupado[chave].lucroLiquido += lucro;
      agrupado[chave].meuLucro += gastos.meuLucro;
    });

    return Object.values(agrupado)
      .sort((a, b) => a.inicio - b.inicio)
      .map((semana) => {
        const base =
          tipoRoyalties === "bruto"
            ? semana.faturamento
            : semana.lucroLiquido;

        const royalties = royaltiesAtivo
          ? (base * Number(percentualRoyalties || 0)) / 100
          : 0;

        const restante = semana.lucroLiquido - royalties - Number(semana.creditoServidor || 0);

        return {
          ...semana,
          royalties,
          restante,
        };
      });
  }

  function gerarTextoRelatorio(resumo, royalties, semanasRoyalties) {
    const textoOutrosGastos = `🧾 Outros gastos - ${formatarValor(resumo.outrosGastos)}`;

    const listaDevolucoes =
      Array.isArray(resumo.devolucoesDetalhadas) && resumo.devolucoesDetalhadas.length > 0
        ? `\n${resumo.devolucoesDetalhadas
            .map((item) => {
              const anexo =
                item.comprovanteUrl || item.arquivoUrl
                  ? ` (comprovante anexado)`
                  : "";

              return `• ${item.descricao || "Devolução / estorno"}: ${formatarValor(item.valor)}${anexo}`;
            })
            .join("\n")}`
        : "";

    const textoDevolucoes =
      Number(resumo.devolucoes || 0) > 0
        ? `\n🔁 Devoluções / estornos - ${formatarValor(resumo.devolucoes)}${listaDevolucoes}`
        : "";

    const colaborador = ehColaboradorUsuario();

    const textoCreditos =
      colaborador
        ? ""
        : Number(resumo.creditoServidor || 0) > 0
        ? `\n💳 Créditos do servidor - ${formatarValor(
            resumo.creditoServidor || 0
          )}`
        : "";

    const textoRoyalties =
      colaborador
        ? ""
        : royaltiesAtivo
        ? `\n\n💎 Royalties (${Number(percentualRoyalties || 0)}% sobre ${
            tipoRoyalties === "bruto" ? "bruto" : "líquido"
          }) - ${formatarValor(royalties)}`
        : "";

    const textoRoyaltiesSemanal =
      !colaborador && royaltiesAtivo && semanasRoyalties.length > 0
        ? `\n\n📅 ROYALTIES SEMANAL\n${semanasRoyalties
            .map(
              (semana) =>
                `- Semana ${semana.periodo}\n\n${nomeRoyalties}: ${formatarValor(
                  semana.royalties
                )}\n${nomeResponsavel}: ${formatarValor(semana.restante)}`
            )
            .join("\n\n")}`
        : "";

    const valorBancoNumero = moedaParaNumero(valorBanco);
    const valorSistemaBanco = Math.max(
      Number(resumo.faturamentoBruto || 0),
      Number(resumo.faturamento || 0) + Number(resumo.devolucoes || 0)
    );
    const diferencaBanco = valorBancoNumero - valorSistemaBanco;

    const textoBanco =
      valorBancoNumero > 0
        ? `\n\n🏦 Fechamento bancário\nBanco: ${bancoNome || "Não informado"}\nValor no banco: ${formatarValor(valorBancoNumero)}\nValor no sistema: ${formatarValor(valorSistemaBanco)}\nDiferença: ${formatarValor(Math.abs(diferencaBanco))}\nStatus: ${
            Math.abs(diferencaBanco) < 0.01 ? "✅ Conferido" : "⚠️ Divergente"
          }`
        : "";

    return `📊 ${tituloRelatorio()}\n📅 ${nomePeriodo()}\n\n💰 Entrada bruta - ${formatarValor(resumo.faturamentoBruto || resumo.faturamento)}${textoDevolucoes}\n✅ Entrada válida - ${formatarValor(resumo.faturamento)}\n\n📢 Gastos com tráfego - ${formatarValor(resumo.trafego)}\n${textoOutrosGastos}\n📉 Total de gastos - ${formatarValor(resumo.totalGastos)}\n\n✅ Total de lucro - ${formatarValor(resumo.lucroLiquido)}${textoCreditos}${textoRoyalties}${textoRoyaltiesSemanal}${textoBanco}\n\n🆕 Vendas novas: ${resumo.vendasNovas}\n🔁 Renovações: ${resumo.renovacoes}\n📦 Total de vendas: ${resumo.vendasNovas + resumo.renovacoes}`;
  }

  function imagemPodeSerCompactada(arquivo) {
    if (!arquivo) return false;

    const tipo = String(arquivo.type || "").toLowerCase();
    const nome = String(arquivo.name || "").toLowerCase();

    if (tipo === "application/pdf" || nome.endsWith(".pdf")) return false;
    if (tipo.includes("heic") || tipo.includes("heif")) return false;
    if (nome.endsWith(".heic") || nome.endsWith(".heif")) return false;

    return tipo.startsWith("image/") || /\.(png|jpg|jpeg|webp)$/i.test(nome);
  }

  function compactarImagemParaUpload(arquivo) {
    return new Promise((resolve) => {
      if (!imagemPodeSerCompactada(arquivo)) {
        resolve(arquivo);
        return;
      }

      const urlTemporaria = URL.createObjectURL(arquivo);
      const img = new Image();

      img.onload = () => {
        try {
          const maxLado = 1400;
          let width = img.width;
          let height = img.height;

          if (width > height && width > maxLado) {
            height = Math.round((height * maxLado) / width);
            width = maxLado;
          } else if (height >= width && height > maxLado) {
            width = Math.round((width * maxLado) / height);
            height = maxLado;
          }

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              URL.revokeObjectURL(urlTemporaria);

              if (!blob) {
                resolve(arquivo);
                return;
              }

              const nomeBase = String(arquivo.name || "anexo")
                .replace(/\.[^.]+$/, "")
                .replace(/[^a-zA-Z0-9._-]/g, "-")
                .slice(0, 70);

              const compactado = new File(
                [blob],
                `${nomeBase || "anexo"}-mobile.jpg`,
                { type: "image/jpeg" }
              );

              resolve(compactado.size < arquivo.size ? compactado : arquivo);
            },
            "image/jpeg",
            0.78
          );
        } catch (err) {
          console.log("Erro ao compactar imagem para upload:", err);
          URL.revokeObjectURL(urlTemporaria);
          resolve(arquivo);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(urlTemporaria);
        resolve(arquivo);
      };

      img.src = urlTemporaria;
    });
  }


  function arquivoParaBase64(arquivo) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const resultado = String(reader.result || "");
        const base64 = resultado.includes(",")
          ? resultado.split(",").pop()
          : resultado;

        resolve(base64);
      };

      reader.onerror = () => {
        reject(new Error("Não consegui preparar o arquivo para envio."));
      };

      reader.readAsDataURL(arquivo);
    });
  }

  async function enviarArquivoBancoBase64(arquivoOriginal) {
    let arquivoParaEnviar = arquivoOriginal;

    if (imagemPodeSerCompactada(arquivoOriginal)) {
      arquivoParaEnviar = await compactarImagemParaUpload(arquivoOriginal, {
        maxLado: 1200,
        qualidade: 0.76,
      });
    }

    const tamanhoMb = arquivoParaEnviar.size / (1024 * 1024);

    if (tamanhoMb > 8) {
      throw new Error(
        `Arquivo ainda ficou grande (${tamanhoMb.toFixed(
          1
        )}MB). Recorte mais o print e tente novamente.`
      );
    }

    const arquivoBase64 = await arquivoParaBase64(arquivoParaEnviar);

    const res = await fetch(`${API_BASE}/relatorio-diario/anexar-banco-base64`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getTokenAtual(),
      },
      body: JSON.stringify({
        nomeArquivo: arquivoParaEnviar.name || `banco-${Date.now()}.jpg`,
        mimeType: arquivoParaEnviar.type || "image/jpeg",
        arquivoBase64,
      }),
    });

    let dados = {};

    try {
      dados = await res.json();
    } catch {
      dados = { error: "Erro ao processar resposta do servidor." };
    }

    if (!res.ok) {
      throw new Error(dados.error || "Erro ao enviar arquivo em modo compatível.");
    }

    return dados;
  }


  function enviarArquivoComXHR(arquivoParaEnviar) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      formData.append(
        "arquivo",
        arquivoParaEnviar,
        arquivoParaEnviar.name || `anexo-${Date.now()}`
      );

      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${API_BASE}/relatorio-diario/anexar-banco`);
      xhr.setRequestHeader("Authorization", getTokenAtual());
      xhr.timeout = 120000;

      xhr.onload = () => {
        let dados = {};

        try {
          dados = JSON.parse(xhr.responseText || "{}");
        } catch {
          dados = { error: "Erro ao processar resposta do servidor." };
        }

        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(dados);
          return;
        }

        reject(new Error(dados.error || "Erro ao enviar arquivo."));
      };

      xhr.onerror = () => {
        reject(new Error("Falha de conexão ao enviar arquivo."));
      };

      xhr.ontimeout = () => {
        reject(new Error("Tempo esgotado ao enviar arquivo. Tente uma imagem menor."));
      };

      xhr.send(formData);
    });
  }

  async function enviarArquivoComFetch(arquivoParaEnviar) {
    const formData = new FormData();

    formData.append(
      "arquivo",
      arquivoParaEnviar,
      arquivoParaEnviar.name || `anexo-${Date.now()}`
    );

    let res;

    try {
      res = await fetch(`${API_BASE}/relatorio-diario/anexar-banco`, {
        method: "POST",
        headers: {
          Authorization: getTokenAtual(),
        },
        body: formData,
      });
    } catch {
      throw new Error("Falha de conexão ao enviar arquivo.");
    }

    let dados = {};

    try {
      dados = await res.json();
    } catch {
      dados = { error: "Erro ao processar resposta do servidor." };
    }

    if (!res.ok) {
      throw new Error(dados.error || "Erro ao enviar arquivo.");
    }

    return dados;
  }

  async function enviarArquivoComFallbackMobile(arquivoOriginal) {
    let erroPrincipal = null;

    try {
      return await enviarArquivoComXHR(arquivoOriginal);
    } catch (err) {
      erroPrincipal = err;
      console.log("Upload via XHR falhou. Tentando fetch:", err);
    }

    try {
      return await enviarArquivoComFetch(arquivoOriginal);
    } catch (err) {
      erroPrincipal = err;
      console.log("Upload via fetch falhou. Tentando imagem compactada:", err);
    }

    const tamanhoMbOriginal = arquivoOriginal.size / (1024 * 1024);

    if (imagemPodeSerCompactada(arquivoOriginal) && tamanhoMbOriginal > 1.5) {
      const arquivoCompactado = await compactarImagemParaUpload(arquivoOriginal);

      if (arquivoCompactado && arquivoCompactado.size < arquivoOriginal.size) {
        try {
          return await enviarArquivoComXHR(arquivoCompactado);
        } catch (err) {
          console.log("Upload compactado via XHR falhou. Tentando fetch:", err);
        }

        try {
          return await enviarArquivoComFetch(arquivoCompactado);
        } catch (err) {
          erroPrincipal = err;
          console.log("Upload compactado via fetch falhou:", err);
        }
      }
    }

    throw new Error(
      erroPrincipal?.message ||
        "Falha ao enviar arquivo. Tente recortar o print ou enviar uma imagem menor."
    );
  }

  async function uploadArquivoGenerico(arquivo) {
    if (!arquivo) {
      throw new Error("Arquivo não informado.");
    }

    let arquivoParaEnviar = arquivo;

    const tamanhoMbOriginal = arquivo.size / (1024 * 1024);

    // IMPORTANTE:
    // Não compacta prints normais do celular, porque alguns Androids podem gerar
    // imagem preta/corrompida ao converter via canvas.
    // Só compacta imagens grandes para evitar falha de upload no mobile.
    if (imagemPodeSerCompactada(arquivo) && tamanhoMbOriginal > 8) {
      arquivoParaEnviar = await compactarImagemParaUpload(arquivo);
    }

    const tamanhoMb = arquivoParaEnviar.size / (1024 * 1024);

    if (tamanhoMb > 45) {
      throw new Error(
        `Arquivo muito grande (${tamanhoMb.toFixed(
          1
        )}MB). Recorte o print ou envie uma imagem menor.`
      );
    }

    return await enviarArquivoComFallbackMobile(arquivoParaEnviar);
  }

  async function uploadPrintBancoConsolidado() {
    if (!arquivoBanco) {
      return {
        bancoPrintUrl,
        bancoPrintTipo,
      };
    }

    const tamanhoOriginalMb = arquivoBanco.size / (1024 * 1024);

    if (tamanhoOriginalMb > 60) {
      throw new Error(
        `Arquivo muito grande (${tamanhoOriginalMb.toFixed(
          1
        )}MB). Recorte o print ou envie uma imagem menor.`
      );
    }

    let arquivoPreparado = arquivoBanco;

    try {
      if (imagemPodeSerCompactada(arquivoBanco) && tamanhoOriginalMb > 3) {
        arquivoPreparado = await compactarImagemParaUpload(arquivoBanco, {
          maxLado: 1400,
          qualidade: 0.82,
        });
      }
    } catch (err) {
      console.log("Falha ao preparar banco para upload:", err);
      arquivoPreparado = arquivoBanco;
    }

    let dados;

    try {
      dados = await enviarArquivoComFallbackMobile(arquivoPreparado);
    } catch (err) {
      console.log("Upload multipart falhou no mobile. Tentando base64:", err);

      // Fallback definitivo para celular:
      // alguns navegadores mobile falham com multipart/form-data,
      // então enviamos o arquivo convertido em JSON/base64.
      dados = await enviarArquivoBancoBase64(arquivoBanco);
    }

    setBancoPrintUrl(dados.bancoPrintUrl);
    setBancoPrintTipo(dados.bancoPrintTipo || arquivoPreparado.type || arquivoBanco.type || "");

    return {
      ...dados,
      bancoPrintTipo: dados.bancoPrintTipo || arquivoPreparado.type || arquivoBanco.type || "",
    };
  }


  async function uploadPrintOutroBancoConsolidado() {
    if (!arquivoOutroBanco) {
      return {
        bancoPrintUrl: outroBancoPrintUrl,
        bancoPrintTipo: outroBancoPrintTipo,
      };
    }

    const tamanhoOriginalMb = arquivoOutroBanco.size / (1024 * 1024);

    if (tamanhoOriginalMb > 60) {
      throw new Error(
        `Arquivo muito grande (${tamanhoOriginalMb.toFixed(
          1
        )}MB). Recorte o print ou envie uma imagem menor.`
      );
    }

    let arquivoPreparado = arquivoOutroBanco;

    try {
      if (imagemPodeSerCompactada(arquivoOutroBanco) && tamanhoOriginalMb > 3) {
        arquivoPreparado = await compactarImagemParaUpload(arquivoOutroBanco, {
          maxLado: 1400,
          qualidade: 0.82,
        });
      }
    } catch (err) {
      console.log("Falha ao preparar outro banco para upload:", err);
      arquivoPreparado = arquivoOutroBanco;
    }

    let dados;

    try {
      dados = await enviarArquivoComFallbackMobile(arquivoPreparado);
    } catch (err) {
      console.log(
        "Upload do outro banco via multipart falhou no mobile. Tentando base64:",
        err
      );

      dados = await enviarArquivoBancoBase64(arquivoOutroBanco);
    }

    const tipoFinal =
      dados.bancoPrintTipo ||
      arquivoPreparado.type ||
      arquivoOutroBanco.type ||
      "";

    setOutroBancoPrintUrl(dados.bancoPrintUrl);
    setOutroBancoPrintTipo(tipoFinal);

    return {
      ...dados,
      bancoPrintTipo: tipoFinal,
    };
  }

  async function uploadPrintTrafegoConsolidado() {
    if (!arquivoTrafego) {
      return {
        trafegoPrintUrl,
        trafegoPrintTipo,
      };
    }

    const dados = await uploadArquivoGenerico(arquivoTrafego);

    setTrafegoPrintUrl(dados.bancoPrintUrl);
    setTrafegoPrintTipo(dados.bancoPrintTipo);

    return {
      trafegoPrintUrl: dados.bancoPrintUrl,
      trafegoPrintTipo: dados.bancoPrintTipo,
    };
  }

  async function lerPrintBanco(e) {
    const arquivo = e.target.files[0];
    e.target.value = "";

    if (!arquivo) return;

    setArquivoBanco(arquivo);
    setBancoPrintUrl("");
    setBancoPrintTipo("");

    if (arquivo.type === "application/pdf") {
      mostrarToast("PDF do banco anexado ao fechamento consolidado.");
      return;
    }

    const formData = new FormData();
    
      let arquivoOCR = arquivo;

      try {
        const tamanhoMbOCR = arquivo.size / (1024 * 1024);

        if (imagemPodeSerCompactada(arquivo) && tamanhoMbOCR > 2) {
          arquivoOCR = await compactarImagemParaUpload(arquivo);
        }
      } catch (err) {
        console.log("Falha ao otimizar OCR:", err);
      }

      formData.append("comprovante", arquivoOCR);


    setLendoBanco(true);

    try {
      const res = await fetch(`${API_BASE}/ler-comprovante`, {
        method: "POST",
        headers: {
          Authorization: getTokenAtual(),
        },
        body: formData,
      });

      const resposta = await res.json();

      if (!res.ok) {
        mostrarToast(resposta.error || "Erro ao ler print do banco");
        return;
      }

      if (resposta.valor === null || resposta.valor === undefined) {
        mostrarToast("Não encontrei o valor no print. Digite manualmente.");
        return;
      }

      setValorBanco(formatarNumeroComoMoeda(Number(resposta.valor || 0)));
      mostrarToast("Valor do banco detectado com sucesso.");
    } catch (err) {
      console.log("Erro ao ler print do banco:", err);
      mostrarToast("Print do banco anexado. Não consegui ler o valor automaticamente; digite manualmente.");
    } finally {
      setLendoBanco(false);
    }
  }


  function lerPrintOutroBanco(e) {
    const arquivo = e.target.files?.[0] || null;
    e.target.value = "";

    if (!arquivo) return;

    setArquivoOutroBanco(arquivo);
    setOutroBancoPrintUrl("");
    setOutroBancoPrintTipo("");

    mostrarToast("Print do Outro banco anexado ao fechamento consolidado.");
  }

  function lerPrintTrafego(e) {
    const arquivo = e.target.files[0];
    e.target.value = "";

    if (!arquivo) return;

    setArquivoTrafego(arquivo);
    setTrafegoPrintUrl("");
    setTrafegoPrintTipo("");

    mostrarToast("Print do tráfego pago anexado como opcional.");
  }

  async function gerarRelatorio() {
    if (!getTokenAtual()) {
      window.location.href = "/";
      return;
    }

    if (periodo === "manual") {
      const periodoSelecionado = obterPeriodoSelecionado();

      if (!periodoSelecionado.inicio || !periodoSelecionado.fim) {
        mostrarToast("Informe a data inicial e a data final do período manual.");
        return;
      }
    }

    const meRes = await fetch(`${API_BASE}/me`, {
      headers: {
        Authorization: getTokenAtual(),
      },
    });

    const usuarioLogado = await meRes.json();
    setMe(usuarioLogado);

    const res = await fetch(`${API_BASE}/meus-relatorios`, {
      headers: {
        Authorization: getTokenAtual(),
      },
    });

    const dados = await res.json();

    if (!Array.isArray(dados)) {
      mostrarToast("Erro ao buscar relatórios");
      return;
    }

    const relatoriosSomados = dados.filter((item) =>
      relatorioPertenceAoGrupoDaFranquia(item, usuarioLogado)
    );

    const filtrados = relatoriosSomados.filter((item) =>
      dentroDoPeriodo(item.data)
    );

    const outrosGastosDetalhados = agruparOutrosGastos(filtrados);
    const devolucoesDetalhadas = agruparDevolucoes(filtrados);

    const resumo = filtrados.reduce(
      (acc, item) => {
        const gastos = calcularGastosDoRelatorio(item);

        const totalGastos =
          Number(item.totalGastos || 0) || gastos.totalGastosCalculado;

        const lucro =
          Number(item.lucroLiquido || 0) ||
          Number(item.faturamento || 0) - totalGastos;

        const devolucoesItem = calcularDevolucoesDoRelatorio(item);
        const faturamentoValidoItem = calcularFaturamentoValidoDoRelatorio(item);
        const entradaBrutaItem = calcularEntradaBrutaDoRelatorio(item);

        acc.faturamento += faturamentoValidoItem;
        acc.faturamentoBruto += entradaBrutaItem;
        acc.devolucoes += devolucoesItem;
        acc.trafego += gastos.trafego;
        acc.outrosGastos += gastos.outrosGastos;
        acc.totalGastos += totalGastos;
        acc.lucroLiquido += lucro;
        acc.creditoServidor += gastos.creditoServidor;
        acc.meuLucro += gastos.meuLucro;
        acc.vendasNovas += Number(item.vendasNovas || 0);
        acc.renovacoes += Number(item.renovacoes || 0);

        return acc;
      },
      {
        faturamento: 0,
        trafego: 0,
        outrosGastos: 0,
        totalGastos: 0,
        lucroLiquido: 0,
        creditoServidor: 0,
        meuLucro: 0,
        vendasNovas: 0,
        renovacoes: 0,
        outrosGastosDetalhados,
        devolucoesDetalhadas,
        devolucoes: 0,
        faturamentoBruto: 0,
      }
    );

    const royalties = calcularRoyalties(resumo);
    const semanasRoyalties = gerarRoyaltiesSemanais(filtrados);

    setResultado({
      ...resumo,
      royalties,
      meuLucro: calcularMeuLucroResumo(resumo, royalties),
    });

    setRoyaltiesSemanais(semanasRoyalties);
    setTextoWhatsApp(gerarTextoRelatorio(resumo, royalties, semanasRoyalties));
    setDadosGrafico(gerarDadosGraficoMensal(relatoriosSomados));
    await carregarHistoricoConsolidado();
  }

  function copiarTexto() {
    navigator.clipboard.writeText(textoWhatsApp);
    mostrarToast("Texto copiado!");
  }

  function atualizarTextoComBanco() {
    if (!resultado) {
      mostrarToast("Gere o relatório primeiro.");
      return;
    }

    setTextoWhatsApp(
      gerarTextoRelatorio(resultado, resultado.royalties, royaltiesSemanais)
    );

    mostrarToast("Fechamento consolidado atualizado no texto.");
  }

  async function enviarParaSistema() {
    if (!resultado) {
      mostrarToast("Gere o relatório consolidado primeiro.");
      return;
    }

    if (!textoWhatsApp) {
      mostrarToast("Atualize o texto do relatório antes de enviar.");
      return;
    }

    const colaborador = ehColaboradorUsuario();
    const roleAtual = String(me?.role || "").toLowerCase();

    try {
      setEnviandoSistema(true);

      const podeAnexarBanco = !colaborador;
      const precisaAnexarBanco =
        podeAnexarBanco && roleAtual === "franquia";

      let uploadBancoInter = {
        bancoPrintUrl: bancoPrintUrl || "",
        bancoPrintTipo: bancoPrintTipo || "",
      };

      let uploadOutroBanco = {
        bancoPrintUrl: outroBancoPrintUrl || "",
        bancoPrintTipo: outroBancoPrintTipo || "",
      };

      if (podeAnexarBanco) {
        if (arquivoBanco || bancoPrintUrl) {
          uploadBancoInter = await uploadPrintBancoConsolidado();
        }

        if (arquivoOutroBanco || outroBancoPrintUrl) {
          uploadOutroBanco = await uploadPrintOutroBancoConsolidado();
        }
      }

      const anexosBancoEnvio = [];

      if (uploadBancoInter?.bancoPrintUrl) {
        anexosBancoEnvio.push({
          url: uploadBancoInter.bancoPrintUrl,
          tipo: uploadBancoInter.bancoPrintTipo || "",
          nome: "Banco Inter",
          tamanho: Number(arquivoBanco?.size || 0),
        });
      }

      if (uploadOutroBanco?.bancoPrintUrl) {
        anexosBancoEnvio.push({
          url: uploadOutroBanco.bancoPrintUrl,
          tipo: uploadOutroBanco.bancoPrintTipo || "",
          nome: "Outro banco",
          tamanho: Number(arquivoOutroBanco?.size || 0),
        });
      }

      if (precisaAnexarBanco && anexosBancoEnvio.length === 0) {
        mostrarToast(
          "Anexe pelo menos 1 print de banco para enviar o fechamento consolidado."
        );
        return;
      }

      const uploadTrafego = arquivoTrafego
        ? await uploadPrintTrafegoConsolidado()
        : {
            trafegoPrintUrl: trafegoPrintUrl || "",
            trafegoPrintTipo: trafegoPrintTipo || "",
          };

      const periodoSelecionado = obterPeriodoSelecionado();
      const valorBancoNumero = colaborador ? 0 : moedaParaNumero(valorBanco);

      const baseRoyalties =
        tipoRoyalties === "bruto"
          ? Number(resultado.faturamento || 0)
          : Number(resultado.lucroLiquido || 0);

      const valorRoyalties =
        !colaborador && royaltiesAtivo
          ? (baseRoyalties * Number(percentualRoyalties || 0)) / 100
          : 0;

      const valorRestante = colaborador
        ? Number(resultado.lucroLiquido || 0)
        : Number(resultado.lucroLiquido || 0) -
          Number(resultado.creditoServidor || 0) -
          Number(valorRoyalties || 0);

      const body = {
        tipo: tipoConsolidado(),
        periodoInicio: periodoSelecionado.inicio,
        periodoFim: periodoSelecionado.fim,
        titulo: tituloRelatorio(),
        faturamento: Number(resultado.faturamento || 0),
        faturamentoBruto: Number(resultado.faturamentoBruto || resultado.faturamento || 0),
        devolucoes: resultado.devolucoesDetalhadas || [],
        totalDevolucoes: Number(resultado.devolucoes || 0),
        vendasNovas: Number(resultado.vendasNovas || 0),
        renovacoes: Number(resultado.renovacoes || 0),
        leads: Number(resultado.leads || 0),
        gastoTrafego: Number(resultado.trafego || 0),
        creditoServidor: colaborador ? 0 : Number(resultado.creditoServidor || 0),
        lucroRealEmpresa:
          Number(resultado.lucroLiquido || 0) -
          (colaborador ? 0 : Number(resultado.creditoServidor || 0)),
        outrosGastos: resultado.outrosGastosDetalhados || [],
        totalVendas:
          Number(resultado.vendasNovas || 0) + Number(resultado.renovacoes || 0),
        totalOutrosGastos: Number(resultado.outrosGastos || 0),
        totalGastos: Number(resultado.totalGastos || 0),
        lucroLiquido: Number(resultado.lucroLiquido || 0),
        royalties: {
          ativo: colaborador ? false : Boolean(royaltiesAtivo),
          percentual: colaborador ? 0 : Number(percentualRoyalties || 0),
          tipo: colaborador ? "liquido" : tipoRoyalties,
          nomeRecebedor: colaborador ? "" : nomeRoyalties,
          nomeResponsavel: colaborador ? "" : nomeResponsavel,
          valorRoyalties,
          valorRestante,
        },
        bancoNome: colaborador ? "" : bancoNome,
        valorBanco: colaborador ? 0 : valorBancoNumero,
        bancoPrintUrl:
          colaborador ? "" : anexosBancoEnvio[0]?.url || "",
        bancoPrintTipo:
          colaborador ? "" : anexosBancoEnvio[0]?.tipo || "",
        anexosBanco: colaborador ? [] : anexosBancoEnvio,
        trafegoPrintUrl: uploadTrafego.trafegoPrintUrl || "",
        trafegoPrintTipo: uploadTrafego.trafegoPrintTipo || "",
        trafegoPrintOpcional: true,
        colaboradorSemBanco: colaborador,
        mensagemWhatsapp: textoWhatsApp,
      };

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 120000);

      let res;

      try {
        res = await fetch(`${API_BASE}/relatorio-consolidado`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: getTokenAtual(),
          },
          body: JSON.stringify(body),
          signal: controller.signal,
        });
      } finally {
        clearTimeout(timeoutId);
      }

      let dados = {};

      try {
        dados = await res.json();
      } catch {
        dados = { error: "Erro ao processar resposta do servidor." };
      }

      if (!res.ok) {
        mostrarToast(dados.error || "Erro ao enviar para o sistema.");
        return;
      }

      mostrarToast("Fechamento semanal enviado para aprovação.");
      await carregarHistoricoConsolidado();
    } catch (err) {
      console.log(err);

      if (err?.name === "AbortError") {
        mostrarToast("Tempo esgotado ao enviar. Tente novamente com internet melhor.");
      } else {
        mostrarToast(err.message || "Erro ao enviar relatório.");
      }
    } finally {
      setEnviandoSistema(false);
    }
  }

  const valorBancoNumero = moedaParaNumero(valorBanco);
  const valorSistemaBanco = resultado
    ? Math.max(
        Number(resultado.faturamentoBruto || 0),
        Number(resultado.faturamento || 0) + Number(resultado.devolucoes || 0)
      )
    : 0;
  const diferencaBanco = resultado ? valorBancoNumero - valorSistemaBanco : 0;

  return (
    <div style={container}>
      {toast && <div style={toastBox}>{toast}</div>}

      <h1>📄 Fechamento Semanal</h1>

      <div style={box}>
        <h2>Filtro do relatório</h2>

        <select
          style={input}
          value={periodo}
          onChange={(e) => setPeriodo(e.target.value)}
        >
          <option value="semana">Semana atual</option>
          <option value="semana_anterior">Semana anterior</option>
          <option value="manual">Período manual</option>
          <option value="mes">Mês atual</option>
          <option value="3meses">Últimos 3 meses</option>
          <option value="ano">Ano atual</option>
        </select>

        {periodo === "manual" && (
          <div style={gridManualPeriodo}>
            <div>
              <strong>Data inicial</strong>
              <input
                style={{ ...input, width: "100%", marginTop: 6, cursor: "pointer" }}
                type="date"
                value={dataManualInicio}
                onMouseDown={(e) => {
                  if (typeof e.currentTarget.showPicker === "function") {
                    try {
                      e.currentTarget.showPicker();
                    } catch {
                      e.currentTarget.focus();
                    }
                  }
                }}
                onChange={(e) => setDataManualInicio(e.target.value)}
              />
            </div>

            <div>
              <strong>Data final</strong>
              <input
                style={{ ...input, width: "100%", marginTop: 6, cursor: "pointer" }}
                type="date"
                value={dataManualFim}
                onMouseDown={(e) => {
                  if (typeof e.currentTarget.showPicker === "function") {
                    try {
                      e.currentTarget.showPicker();
                    } catch {
                      e.currentTarget.focus();
                    }
                  }
                }}
                onChange={(e) => setDataManualFim(e.target.value)}
              />
            </div>
          </div>
        )}

        {!ehColaboradorUsuario() && (
          <label style={toggleLabel}>
            <input
              type="checkbox"
              checked={royaltiesAtivo}
              onChange={(e) => {
                const novoValor = e.target.checked;
                setRoyaltiesAtivo(novoValor);
                salvarConfiguracoes({ ativo: novoValor });
              }}
            />
            Ativar royalties
          </label>
        )}

        {!ehColaboradorUsuario() && royaltiesAtivo && (
          <>
            <select
              style={input}
              value={percentualRoyalties}
              onChange={(e) => {
                const novoValor = e.target.value;
                setPercentualRoyalties(novoValor);
                salvarConfiguracoes({ percentual: novoValor });
              }}
            >
              {opcoesPercentualRoyalties.map((percentual) => (
                <option key={percentual} value={String(percentual)}>
                  {percentual}%
                </option>
              ))}
            </select>

            <select
              style={input}
              value={tipoRoyalties}
              onChange={(e) => {
                const novoValor = e.target.value;
                setTipoRoyalties(novoValor);
                salvarConfiguracoes({ tipo: novoValor });
              }}
            >
              <option value="bruto">Bruto (faturamento)</option>
              <option value="liquido">Líquido (lucro)</option>
            </select>

            <input
              style={input}
              type="text"
              placeholder="Recebedor dos royalties • Ex: SD Vision"
              value={nomeRoyalties}
              onChange={(e) => {
                const novoValor = e.target.value;
                setNomeRoyalties(novoValor);
                salvarConfiguracoes({ nomeRecebedor: novoValor });
              }}
            />

            <input
              style={input}
              type="text"
              placeholder="Responsável pelo faturamento • Ex: Gestor One"
              value={nomeResponsavel}
              onChange={(e) => {
                const novoValor = e.target.value;
                setNomeResponsavel(novoValor);
                salvarConfiguracoes({ nomeResponsavel: novoValor });
              }}
            />
          </>
        )}

        <button style={button} onClick={gerarRelatorio}>
          Gerar fechamento semanal
        </button>
      </div>

      {resultado && (
        <>
          <div style={cards}>
            <Card titulo="Faturamento válido" valor={formatarValor(resultado.faturamento)} />
            <Card titulo="Entrada bruta" valor={formatarValor(resultado.faturamentoBruto || resultado.faturamento)} />
            <Card titulo="Devoluções" valor={formatarValor(resultado.devolucoes || 0)} />
            <Card titulo="Tráfego pago" valor={formatarValor(resultado.trafego)} />
            <Card titulo="Outros gastos" valor={formatarValor(resultado.outrosGastos)} />
            <Card titulo="Total de gastos" valor={formatarValor(resultado.totalGastos)} />
            <Card titulo="Lucro líquido" valor={formatarValor(resultado.lucroLiquido)} />
            <Card titulo="Créditos servidor" valor={formatarValor(resultado.creditoServidor || 0)} />
            <Card
              titulo="Meu lucro"
              valor={formatarValor(
                resultado.meuLucro !== undefined && resultado.meuLucro !== null
                  ? resultado.meuLucro
                  : calcularMeuLucroResumo(resultado, resultado.royalties)
              )}
            />
            <Card titulo="Vendas novas" valor={resultado.vendasNovas} />
            <Card titulo="Renovações" valor={resultado.renovacoes} />
            <Card titulo="Total vendas" valor={resultado.vendasNovas + resultado.renovacoes} />

            {!ehColaboradorUsuario() && royaltiesAtivo && (
              <Card
                titulo={`Royalties ${
                  tipoRoyalties === "bruto" ? "sobre bruto" : "sobre líquido"
                }`}
                valor={formatarValor(resultado.royalties)}
              />
            )}
          </div>

          {!ehColaboradorUsuario() && (
          <div style={box}>
            <h2>🏦 Fechamento bancário consolidado</h2>

            <p style={{ marginTop: 0, color: "#64748b" }}>
              {String(me?.role || "").toLowerCase() === "franquia"
                ? "Anexe pelo menos 1 print. Use Banco Inter e, se houver movimentação em outro banco, use o segundo campo."
                : "Banco Inter e Outro banco ficam disponíveis para conferência. Para Gestor/Master os anexos são opcionais."}
            </p>

            <input
              style={input}
              placeholder="Banco principal"
              value={bancoNome}
              onChange={(e) => setBancoNome(e.target.value)}
            />

            <input
              style={input}
              placeholder="Valor no banco"
              value={valorBanco}
              onChange={(e) => setValorBanco(formatarMoedaInput(e.target.value))}
            />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: 12,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  border: "1px solid #dbe4ee",
                  borderRadius: 12,
                  padding: 12,
                  background: "#f8fafc",
                }}
              >
                <strong style={{ display: "block", marginBottom: 8 }}>
                  🏦 Banco Inter
                </strong>

                <label style={uploadBanco}>
                  {lendoBanco
                    ? "🔎 Lendo print Banco Inter..."
                    : arquivoBanco
                    ? `📎 ${arquivoBanco.name}`
                    : bancoPrintUrl
                    ? "✅ Print Banco Inter anexado"
                    : "📤 Anexar print Banco Inter"}

                  <input
                    type="file"
                    accept="image/*,application/pdf,.heic,.heif"
                    style={{ display: "none" }}
                    onChange={lerPrintBanco}
                    disabled={lendoBanco}
                  />
                </label>

                {bancoPrintUrl && (
                  <a
                    href={normalizarUrl(bancoPrintUrl)}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "inline-block", marginTop: 8 }}
                  >
                    Abrir print Banco Inter
                  </a>
                )}
              </div>

              <div
                style={{
                  border: "1px solid #dbe4ee",
                  borderRadius: 12,
                  padding: 12,
                  background: "#f8fafc",
                }}
              >
                <strong style={{ display: "block", marginBottom: 8 }}>
                  🏦 Outro banco
                </strong>

                <label style={uploadBanco}>
                  {arquivoOutroBanco
                    ? `📎 ${arquivoOutroBanco.name}`
                    : outroBancoPrintUrl
                    ? "✅ Print Outro banco anexado"
                    : "📤 Anexar print Outro banco"}

                  <input
                    type="file"
                    accept="image/*,application/pdf,.heic,.heif"
                    style={{ display: "none" }}
                    onChange={lerPrintOutroBanco}
                  />
                </label>

                {outroBancoPrintUrl && (
                  <a
                    href={normalizarUrl(outroBancoPrintUrl)}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "inline-block", marginTop: 8 }}
                  >
                    Abrir print Outro banco
                  </a>
                )}
              </div>
            </div>

            <label style={uploadTrafego}>
              {arquivoTrafego
                ? `📎 ${arquivoTrafego.name}`
                : trafegoPrintUrl
                ? "✅ Print tráfego anexado"
                : "📎 Anexar print tráfego pago (opcional)"}

              <input
                type="file"
                accept="image/*,application/pdf,.heic,.heif"
                style={{ display: "none" }}
                onChange={lerPrintTrafego}
              />
            </label>

            <button style={button} onClick={atualizarTextoComBanco}>
              Atualizar texto com banco
            </button>

            {valorBancoNumero > 0 && resultado && (
              <div style={cardsBanco}>
                <Card titulo="Sistema" valor={formatarValor(valorSistemaBanco)} />
                <Card titulo="Banco" valor={formatarValor(valorBancoNumero)} />
                <Card titulo="Diferença" valor={formatarValor(Math.abs(diferencaBanco))} />
                <Card
                  titulo="Status"
                  valor={
                    Math.abs(diferencaBanco) < 0.01
                      ? "✅ Conferido"
                      : "⚠️ Divergente"
                  }
                />
              </div>
            )}
          </div>
          )}

          {!ehColaboradorUsuario() && royaltiesAtivo && royaltiesSemanais.length > 0 && (
            <div style={box}>
              <h2>💎 Royalties semanal</h2>

              <div style={cards}>
                {royaltiesSemanais.map((semana, index) => (
                  <div key={index} style={card}>
                    <p style={{ margin: 0, color: "#aaa" }}>
                      Semana {semana.periodo}
                    </p>

                    <h3 style={{ marginTop: 10 }}>
                      {nomeRoyalties}: {formatarValor(semana.royalties)}
                    </h3>

                    <h3>
                      {nomeResponsavel}: {formatarValor(semana.restante)}
                      <br />
                      Créditos: {formatarValor(semana.creditoServidor || 0)}
                      <br />
                      Meu lucro: {formatarValor(semana.meuLucro || 0)}
                    </h3>
                  </div>
                ))}
              </div>
            </div>
          )}

          <GraficoMensal dados={dadosGrafico} />

          <div style={box}>
            <h2>📲 Texto pronto para WhatsApp</h2>

            <pre style={textoBox}>{textoWhatsApp}</pre>

            <div style={botoesAcao}>
              <button style={button} onClick={copiarTexto}>
                Copiar texto
              </button>

              <button
                style={{
                  ...button,
                  background: "#2563eb",
                  opacity: enviandoSistema ? 0.6 : 1,
                }}
                onClick={enviarParaSistema}
                disabled={enviandoSistema}
              >
                {enviandoSistema ? "Enviando..." : "📤 Enviar para o sistema"}
              </button>
            </div>
          </div>
        </>
      )}

      {historicoConsolidado.length > 0 && (
        <div style={box}>
          <h2>📚 Últimos consolidados enviados</h2>

          {historicoConsolidado.map((item) => (
            <div key={item._id} style={linhaHistorico}>
              <div>
                <strong>{item.titulo || "Fechamento semanal"}</strong>
                <p style={textoPequeno}>
                  {item.periodoInicio} a {item.periodoFim}
                </p>
                {!ehColaboradorUsuario() && (
                  <p style={textoPequeno}>Banco: {item.bancoNome || "-"}</p>
                )}
                <p style={textoPequeno}>
                  Tráfego: {item.trafegoPrintUrl ? "anexado" : "opcional / não anexado"}
                </p>
                {item.observacaoAprovacao && (
                  <p style={textoObs}>Obs: {item.observacaoAprovacao}</p>
                )}
              </div>

              <div style={{ textAlign: "right" }}>
                <span style={badgeStatus(item.statusAprovacao)}>
                  {traduzirStatus(item.statusAprovacao)}
                </span>
                {item.statusAprovacao === "aprovado_automaticamente" && (
                  <p style={{ ...textoPequeno, color: "#16a34a", fontWeight: 700 }}>
                    OCR compatível com faturamento.
                  </p>
                )}
                <p style={textoPequeno}>
                  {formatarValor(item.faturamento || 0)}
                </p>
                {!ehColaboradorUsuario() && (
                  <p style={textoPequeno}>
                    Royalties:{" "}
                    {formatarValor(item.royalties?.valorRoyalties || 0)}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function GraficoMensal({ dados }) {
  if (!dados || dados.length === 0) {
    return (
      <div style={box}>
        <h2>📈 Evolução mensal</h2>
        <p>Nenhum dado mensal encontrado ainda.</p>
      </div>
    );
  }

  const ultimoMes = dados[dados.length - 1];

  return (
    <div style={box}>
      <h2>📈 Evolução mensal</h2>

      <div style={crescimentoCards}>
        <CardCrescimento
          titulo="Crescimento faturamento"
          valor={ultimoMes.crescimentoFaturamento}
        />

        <CardCrescimento
          titulo="Crescimento lucro"
          valor={ultimoMes.crescimentoLucro}
        />
      </div>

      <div style={{ width: "100%", height: 350 }}>
        <ResponsiveContainer>
          <LineChart data={dados}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mes" />

            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />

            <Tooltip formatter={(value) => formatarValor(value)} />
            <Legend />

            <Line
              yAxisId="left"
              type="monotone"
              dataKey="faturamento"
              name="Faturamento"
              strokeWidth={3}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="gastos"
              name="Gastos"
              strokeWidth={3}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="lucro"
              name="Lucro líquido"
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function CardCrescimento({ titulo, valor }) {
  const negativo = typeof valor === "number" && valor < 0;
  const positivo = typeof valor === "number" && valor > 0;

  return (
    <div style={card}>
      <p style={{ margin: 0, color: "#aaa" }}>{titulo}</p>

      <h2
        style={{
          margin: "8px 0 0",
          color: positivo ? "#22c55e" : negativo ? "#ef4444" : "white",
        }}
      >
        {formatarCrescimento(valor)}
      </h2>
    </div>
  );
}

function traduzirStatus(status) {
  const mapa = {
    pendente: "🟡 Pendente",
    aprovado: "🟢 Aprovado",
    aprovado_automaticamente: "✅ Validado automaticamente",
    rejeitado: "🔴 Rejeitado",
    aguardando_correcao: "🟠 Correção",
  };

  return mapa[status] || "🟡 Pendente";
}

function badgeStatus(status) {
  const base = {
    display: "inline-block",
    padding: "7px 10px",
    borderRadius: 999,
    fontWeight: "bold",
    fontSize: 12,
  };

  if (status === "aprovado" || status === "aprovado_automaticamente") {
    return { ...base, background: "#dcfce7", color: "#166534" };
  }

  if (status === "rejeitado") {
    return { ...base, background: "#fee2e2", color: "#991b1b" };
  }

  if (status === "aguardando_correcao") {
    return { ...base, background: "#ffedd5", color: "#9a3412" };
  }

  return { ...base, background: "#fef9c3", color: "#854d0e" };
}

function formatarCrescimento(valor) {
  if (valor === null || valor === undefined) return "--";
  if (valor === "queda") return "queda no lucro";
  if (valor > 0) return `+${valor}%`;
  return `${valor}%`;
}

function formatarValor(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function Card({ titulo, valor }) {
  return (
    <div style={card}>
      <p style={{ margin: 0, color: "#aaa" }}>{titulo}</p>
      <h2 style={{ margin: "8px 0 0" }}>{valor}</h2>
    </div>
  );
}


const gridManualPeriodo = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: 12,
  marginTop: 12,
  marginBottom: 12,
};

const container = {
  padding: 40,
  fontFamily: "Arial",
};

const box = {
  background: "#f8fafc",
  padding: 24,
  borderRadius: 14,
  marginBottom: 24,
};

const input = {
  padding: 12,
  borderRadius: 8,
  border: "1px solid #ccc",
  marginRight: 12,
  marginTop: 8,
};

const button = {
  padding: "12px 20px",
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  marginTop: 8,
  marginRight: 8,
  fontWeight: "bold",
};

const uploadBanco = {
  display: "inline-block",
  padding: "12px 18px",
  background: "#2563eb",
  color: "white",
  borderRadius: 10,
  cursor: "pointer",
  fontWeight: "bold",
  marginTop: 8,
  marginRight: 8,
};

const uploadTrafego = {
  display: "inline-block",
  padding: "12px 18px",
  background: "#16a34a",
  color: "white",
  borderRadius: 10,
  cursor: "pointer",
  fontWeight: "bold",
  marginTop: 8,
  marginRight: 8,
};

const toggleLabel = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  marginRight: 12,
  marginTop: 8,
  fontWeight: "bold",
};

const cards = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: 16,
  marginBottom: 24,
};

const cardsBanco = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: 16,
  marginTop: 20,
};

const crescimentoCards = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: 16,
  marginBottom: 24,
};

const card = {
  background: "#0f172a",
  color: "white",
  padding: 20,
  borderRadius: 14,
};

const textoBox = {
  background: "white",
  padding: 20,
  borderRadius: 10,
  whiteSpace: "pre-wrap",
  fontFamily: "Arial",
};

const botoesAcao = {
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
};

const toastBox = {
  position: "fixed",
  right: 20,
  top: 20,
  background: "#0f172a",
  color: "white",
  padding: "14px 18px",
  borderRadius: 12,
  boxShadow: "0 15px 35px rgba(0,0,0,0.25)",
  zIndex: 9999,
  fontWeight: "bold",
};

const linhaHistorico = {
  display: "flex",
  justifyContent: "space-between",
  gap: 16,
  background: "white",
  padding: 16,
  borderRadius: 12,
  marginTop: 12,
};

const textoPequeno = {
  margin: "5px 0 0",
  color: "#64748b",
  fontSize: 13,
};

const textoObs = {
  margin: "8px 0 0",
  color: "#991b1b",
  fontSize: 13,
  fontWeight: "bold",
};
